var baseCreate = require("./_baseCreate"), getPrototype = require("./_getPrototype"), isPrototype = require("./_isPrototype");
function initCloneObject(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;
